import { TableCell, TableRow, Typography } from "@material-ui/core"
import { CircularLoading } from "../../../utils"
import { useCargasProdutosStyles } from "../cargas-produtos-styles"
import { CardProdutosProps } from "./card-produtos-props"
import { alterarCorStatusProdutos } from "../../../../../utils/alterar-cor-status-produtos"
import { alterarNomeStatusProdutos } from "../../../../../utils/alterar-nome-status-produtos"
import classNames from "classnames"


export const CardProdutos = ({
   produtos,
   carregando
}: CardProdutosProps) => {
   const classes = useCargasProdutosStyles()

   return (
      <>
         {carregando ? (
            <CircularLoading tipo="FULLSIZED" />
         ) : null}
         {produtos?.map((produto, index) => (
            <TableRow key={index} className={classNames(index % 2 === 0 && classes.cardCinza, classes.card)}>
               <TableCell>
                  <Typography align='center'>{produto.codigoPrincipal}</Typography>
               </TableCell>
               <TableCell>
                  <Typography align='center'>{produto.descricao}</Typography>
               </TableCell>
               <TableCell align='center'>
                  <Typography>{produto.grupo}</Typography>
               </TableCell>
               <TableCell align='center'>
                  <Typography>{produto?.valor?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Typography>
               </TableCell>
               <TableCell align='center'>
                  <Typography>{produto.ncm}</Typography>
               </TableCell>
               <TableCell align='center'>
                  <Typography>{produto.marca}</Typography>
               </TableCell>
               <TableCell align='center'>
                  <Typography>{produto.medida}</Typography>
               </TableCell>
               <TableCell align='center'>
                  <Typography style={{ background: alterarCorStatusProdutos(produto.status) }} className={classes.titleSituacao}>{alterarNomeStatusProdutos(produto.status)}</Typography>
               </TableCell>
            </TableRow>
         ))}
      </>
   )
}